<div class="p-6">
  <div class="flex justify-between items-center mb-3">
    <h2 class="text-xl font-semibold text-nabp-900">Session Timeout</h2>
    <button (click)="signOut()" class="text-nabp-500 hover:text-nabp-900 transition-colors p-1 rounded focus:outline-none focus-visible:outline-none">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
      </svg>
    </button>
  </div>

  <p class="text-sm leading-6 text-nabp-600">
    You have been inactive for a while. Your session is about to expire.
    You will be logged out in
    <strong class="text-nabp-900">{{ countdown() }}</strong>
    {{ countdown() !== 1 ? 'seconds' : 'second' }}.
    Click <strong class="text-nabp-900">Stay Signed In</strong> to continue or
    <strong class="text-nabp-900">Sign Out</strong> if you're done.
  </p>

  <div class="mt-6 flex justify-end gap-2">
    <button
      (click)="staySignedIn()"
      class="border border-primary text-primary px-4 py-2 rounded text-sm font-medium hover:bg-primary-light transition-colors cursor-pointer bg-transparent">
      Stay Signed In
    </button>
    <button
      (click)="signOut()"
      class="bg-primary text-white px-4 py-2 rounded text-sm font-medium hover:opacity-90 transition-opacity cursor-pointer">
      Sign Out
    </button>
  </div>
</div>
